import APIClient from '@/shared/http/clients/api'

const resourceName = 'VistoriaEpiTipoInconformidade'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetByVistoriaEpi = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByVistoriaEpi/${id}`, data, config)

const surveyepitypenonconformityRepository = {
  GetByVistoriaEpi
}
export default surveyepitypenonconformityRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/surveyepitypenonconformity.js